import { ClearOutlined, InsertChartOutlined } from '@mui/icons-material';
import { TreeItem } from '@mui/lab';
import { IconButton, Stack, Typography } from '@mui/material';
import { useCallback } from 'react';
import { getComposeNodeId } from '../utils/helpers';

function FeatureNode({
  node, selectedNodeId, handleNodeSelect, handleSaveFeature,
}) {
  const handleRemoveFeature = useCallback((e, featureId) => {
    e.stopPropagation();
    const updatedFeatures = node.features?.filter((f) => f.id !== featureId) || [];
    handleSaveFeature(node.id, updatedFeatures, node.level);
    handleNodeSelect(getComposeNodeId(node.id, node.level));
  }, [handleSaveFeature]);

  return (
    node.features.map((f) => {
      const featureNodeId = `${node.id}-${f.id}|0`;
      const isSelected = selectedNodeId === featureNodeId;

      return (
        <TreeItem
          key={featureNodeId}
          nodeId={featureNodeId}
          label={(
            <Stack
              onClick={() => handleNodeSelect(featureNodeId)}
              width="100%"
              sx={{
                my: 0.2,
                borderRadius: 1,
                gap: 1,
                flexDirection: 'row',
                alignItems: 'center',
                color: isSelected ? 'primary.main' : 'inherit',
              }}
            >
              <InsertChartOutlined sx={{ fontSize: 16 }} />
              <Typography sx={{ fontSize: 14 }}>
                {f.featureName}
              </Typography>
              <IconButton size="small" onClick={(e) => handleRemoveFeature(e, f.id)}>
                <ClearOutlined sx={{ fontSize: 16 }} />
              </IconButton>
            </Stack>
          )}
        />
      );
    })
  );
}

export default FeatureNode;
